import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "suggestions", "pillContainer", "hiddenField"]
  static values = { 
    type: String,
    url: String 
  }

  connect() {
    this.tags = this.getCurrentTags()
    this.renderPills()
    this.setupInput()
  }

  getCurrentTags() {
    const hiddenValue = this.hiddenFieldTarget.value
    return hiddenValue ? hiddenValue.split(', ').filter(tag => tag.trim() !== '') : []
  }

  setupInput() {
    this.inputTarget.addEventListener('input', this.handleInput.bind(this))
    this.inputTarget.addEventListener('keydown', this.handleKeydown.bind(this))
    this.inputTarget.addEventListener('blur', this.hideSuggestions.bind(this))
  }

  handleInput(event) {
    const query = event.target.value.trim()
    if (query.length >= 2) {
      this.fetchSuggestions(query)
    } else {
      this.hideSuggestions()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      const value = this.inputTarget.value.trim()
      if (value) {
        this.addTag(value)
      }
    } else if (event.key === 'Escape') {
      this.hideSuggestions()
    }
  }

  async fetchSuggestions(query) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}&type=${this.typeValue}`)
      const suggestions = await response.json()
      this.showSuggestions(suggestions.filter(tag => !this.tags.includes(tag)))
    } catch (error) {
      console.error('Failed to fetch suggestions:', error)
    }
  }

  showSuggestions(suggestions) {
    if (suggestions.length === 0) {
      this.hideSuggestions()
      return
    }

    this.suggestionsTarget.innerHTML = suggestions
      .map(suggestion => `
        <div class="suggestion-item" 
             data-action="click->tags#selectSuggestion" 
             data-value="${suggestion}">
          ${suggestion}
        </div>
      `).join('')
    
    this.suggestionsTarget.classList.remove('d-none')
  }

  hideSuggestions() {
    setTimeout(() => {
      this.suggestionsTarget.classList.add('d-none')
    }, 150) // Delay to allow click events on suggestions
  }

  selectSuggestion(event) {
    const value = event.target.dataset.value
    this.addTag(value)
  }

  addTag(tagName) {
    const trimmedTag = tagName.trim()
    if (trimmedTag && !this.tags.includes(trimmedTag)) {
      this.tags.push(trimmedTag)
      this.updateHiddenField()
      this.renderPills()
      this.inputTarget.value = ''
      this.hideSuggestions()
    }
  }

  removeTag(event) {
    const tagToRemove = event.target.dataset.tag
    this.tags = this.tags.filter(tag => tag !== tagToRemove)
    this.updateHiddenField()
    this.renderPills()
  }

  renderPills() {
    this.pillContainerTarget.innerHTML = this.tags.map(tag => `
      <span class="tag-pill">
        ${tag}
        <button type="button" class="tag-remove" 
                data-action="click->tags#removeTag" 
                data-tag="${tag}" 
                aria-label="Remove ${tag}">
        </button>
      </span>
    `).join('')
  }

  updateHiddenField() {
    this.hiddenFieldTarget.value = this.tags.join(', ')
  }
}